import React, { useEffect, useState, useContext } from "react";
import ConfigVerticalMenu from "./ConfigVerticalMenu";
import v2AppService from "../../../services/api/v2-app-config-services";
import ConfigForm from "./ConfigForm";
import { useHistory } from "react-router-dom";
import formValidations from "../../../variables/form-validations";
import UserContext from "../../../UserContext";
import useDynamicResources from "./useDynamicResources"; // Adjust path as needed
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Spinner,
  Alert,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
} from "reactstrap";




const EditAppTemplate = (props) => {
  const templateId = new URLSearchParams(props.location.search).get('template_id');
  const platform = new URLSearchParams(props.location.search).get('platform');
  const context = useContext(UserContext);
  const [horizontalTab, setHorizontalTab] = useState('app');
  const [configSchema, setConfigSchema] = useState(false);
  const [currentTabConfig, setCurrentTabConfig] = useState(false);
  const [savedConfig, setSavedConfig] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [categories, setCategories] = useState([]);
  const [fieldStates, setFieldStates] = useState(false);
  const [allFieldStates, setAllFieldStates] = useState(false);
  const [formFields, setFormFields] = useState(false);
  const [currentFormFields, setCurrentFormFields] = useState(false);
  const history = useHistory();
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Use the new custom hook
  const { resourceList, isLoading: isLoadingResources, error: resourcesError, refetchResources } = useDynamicResources("", "", templateId, horizontalTab, configSchema);

  // Helper function to generate default config for a tab
  const generateDefaultConfigForTab = (schema, tabName) => {
    if (!schema || !schema[tabName] || !schema[tabName].items) {
      console.log(`Schema not found or items missing for tab in generateDefaultConfigForTab: ${tabName}`);
      return {};
    }

    const tabSchemaItems = schema[tabName].items;
    let defaultConfig = {};

    const buildDefaultConfigRecursive = (items, currentConfigLevel) => {
      for (const key in items) {
        const itemSchema = items[key];
        if (itemSchema.items && typeof itemSchema.items === 'object' && !Array.isArray(itemSchema.items)) {
          currentConfigLevel[key] = {};
          buildDefaultConfigRecursive(itemSchema.items, currentConfigLevel[key]);
        } else if (itemSchema.type === 'multi-input-object') {
          currentConfigLevel[key] = itemSchema.default !== undefined ? itemSchema.default : {};
        } else if (itemSchema.type === 'multi-input') {
          currentConfigLevel[key] = itemSchema.default !== undefined ? itemSchema.default : [];
        } else {
          currentConfigLevel[key] = itemSchema.default !== undefined ? itemSchema.default : "";
          if (itemSchema.type === 'boolean' && itemSchema.default === undefined) {
            currentConfigLevel[key] = false;
          }
        }
      }
    };

    buildDefaultConfigRecursive(tabSchemaItems, defaultConfig);
    return defaultConfig;
  };

  // Effect for initial data load (schema and full saved config)
  useEffect(() => {
    (async () => {
      if (templateId) {
        setShowLoader(true);
        try {
          const schemaResponse = await v2AppService.getV2AppConfigSchema(platform);
          if (schemaResponse.status) {
            setConfigSchema(schemaResponse.data);
          } else {
            setAlert({ show: true, type: 'danger', message: 'Failed to load schema.' });
          }

          const savedConfigResponse = await v2AppService.getAppSavedConfig(templateId);
          if (savedConfigResponse.status) {
            setSavedConfig(savedConfigResponse);
          } else {
            setAlert({ show: true, type: 'danger', message: 'Failed to load saved configuration.' });
          }
        } catch (error) {
          console.log("Error loading initial data:", error);
          setAlert({ show: true, type: 'danger', message: 'Error loading initial data.' });
        } finally {
          setInitialDataLoaded(true);
          setShowLoader(false);
        }
      }
    })();
  }, [templateId,horizontalTab]);

  // Effect for setting currentTabConfig when horizontalTab or savedConfig changes
  useEffect(() => {
    if (initialDataLoaded && savedConfig && savedConfig.data && horizontalTab && configSchema) {
      let currentConfigData = {};
      if (savedConfig.data[horizontalTab]) {
        try {
          currentConfigData = JSON.parse(savedConfig.data[horizontalTab]);
        } catch (e) {
          console.log("Failed to parse current tab config for", horizontalTab, ":", e);
          currentConfigData = generateDefaultConfigForTab(configSchema, horizontalTab);
        }
      } else {
        currentConfigData = generateDefaultConfigForTab(configSchema, horizontalTab);
      }
      setCurrentTabConfig(currentConfigData);
    }
  }, [horizontalTab, savedConfig, initialDataLoaded, configSchema]);

  //for setting form fields validations
  useEffect(() => {
    // console.log(horizontalTab);
    // console.log(currentTabConfig);

    if (configSchema) {
      let fieldStatesData = {}; let formFieldsData = {};
      Object.keys(configSchema).forEach(function (key) {
        Object.keys(configSchema[key]).forEach(function (horizontolmenukey) {
          let menuStateData = {};
          let allFormFields = {};
          var submenu = configSchema[key][horizontolmenukey].items;
          Object.keys(submenu).forEach(function (submenukey) {
            if (submenu[submenukey].items) {
              let submenufields = submenu[submenukey].items;
              Object.keys(submenufields).forEach(function (submenufieldkey) {
                if (submenufields[submenufieldkey].items) {
                  let subheads = submenufields[submenufieldkey].items;
                  Object.keys(subheads).forEach(function (subheadkey) {
                    let elementErrorClass = "error_" + submenukey + ":" + submenufieldkey + ":" + subheadkey;
                    let elementErrorMessageClass = "error_message_" + submenukey + ":" + submenufieldkey + ":" + subheadkey;
                    menuStateData[elementErrorClass] = 'has-success';
                    menuStateData[elementErrorMessageClass] = '';
                    allFormFields[submenukey + ":" + submenufieldkey + ":" + subheadkey] = subheads[subheadkey];
                    let fieldDesign = subheads[subheadkey];
                    if (fieldDesign.type == 'multi-input' && horizontolmenukey == horizontalTab) {
                      if (currentTabConfig[submenukey][submenufieldkey][subheadkey]) {
                        let multiInputFieldValue = currentTabConfig[submenukey][submenufieldkey][subheadkey];
                        Object.keys(multiInputFieldValue).forEach(function (multiInputFieldIndex) {
                          Object.keys(multiInputFieldValue[multiInputFieldIndex]).forEach(function (multiInputFieldName) {
                            let multiInputValue = multiInputFieldValue[multiInputFieldIndex][multiInputFieldName];
                            let multiElementErrorClass = elementErrorClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;
                            let multiElementErrorMessageClass = elementErrorMessageClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;
                            if (!fieldStates[multiElementErrorClass]) {
                              menuStateData[multiElementErrorClass] = 'has-success';
                              menuStateData[multiElementErrorMessageClass] = '';
                            } else {
                              menuStateData[multiElementErrorClass] = fieldStates[multiElementErrorClass];
                              menuStateData[multiElementErrorMessageClass] = fieldStates[multiElementErrorMessageClass];
                            }
                            allFormFields[submenukey + ":" + submenufieldkey + ":" + subheadkey + ":" + multiInputFieldIndex + ":" + multiInputFieldName] = fieldDesign.type_items[0][multiInputFieldName];
                          })
                        })
                      }
                    }
                  })

                } else {
                  let elementErrorClass = "error_" + submenukey + ":" + submenufieldkey;
                  let elementErrorMessageClass = "error_message_" + submenukey + ":" + submenufieldkey;
                  menuStateData[elementErrorClass] = 'has-success';
                  menuStateData[elementErrorMessageClass] = '';
                  allFormFields[submenukey + ":" + submenufieldkey] = submenufields[submenufieldkey];
                  let fieldDesign = submenufields[submenufieldkey];
                  if (fieldDesign.type == 'multi-input' && horizontolmenukey == horizontalTab) {
                    if (currentTabConfig[submenukey] && currentTabConfig[submenukey][submenufieldkey]) {
                      let multiInputFieldValue = currentTabConfig[submenukey][submenufieldkey];
                      Object.keys(multiInputFieldValue).forEach(function (multiInputFieldIndex) {
                        Object.keys(multiInputFieldValue[multiInputFieldIndex]).forEach(function (multiInputFieldName) {
                          let multiInputValue = multiInputFieldValue[multiInputFieldIndex][multiInputFieldName];
                          let multiElementErrorClass = elementErrorClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;
                          let multiElementErrorMessageClass = elementErrorMessageClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;

                          if (!fieldStates[multiElementErrorClass]) {
                            menuStateData[multiElementErrorClass] = 'has-success';
                            menuStateData[multiElementErrorMessageClass] = '';
                          } else {
                            menuStateData[multiElementErrorClass] = fieldStates[multiElementErrorClass];
                            menuStateData[multiElementErrorMessageClass] = fieldStates[multiElementErrorMessageClass];
                          }

                          allFormFields[submenukey + ":" + submenufieldkey + ":" + multiInputFieldIndex + ":" + multiInputFieldName] = fieldDesign.type_items[0][multiInputFieldName];
                        })
                      })
                    }
                  }
                }
              })
            } else {
              let elementErrorClass = "error_" + submenukey;
              let elementErrorMessageClass = "error_message_" + submenukey;
              menuStateData[elementErrorClass] = 'has-success';
              menuStateData[elementErrorMessageClass] = '';
              allFormFields[submenukey] = submenu[submenukey];
              let fieldDesign = submenu[submenukey];
              if (fieldDesign.type == 'multi-input' && horizontolmenukey == horizontalTab) {
                if (currentTabConfig[submenukey]) {
                  let multiInputFieldValue = currentTabConfig[submenukey];
                  Object.keys(multiInputFieldValue).forEach(function (multiInputFieldIndex) {
                    Object.keys(multiInputFieldValue[multiInputFieldIndex]).forEach(function (multiInputFieldName) {
                      let multiInputValue = multiInputFieldValue[multiInputFieldIndex][multiInputFieldName];
                      let multiElementErrorClass = elementErrorClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;
                      let multiElementErrorMessageClass = elementErrorMessageClass + ":" + multiInputFieldIndex + ":" + multiInputFieldName;
                      if (!fieldStates[multiElementErrorClass]) {
                        menuStateData[multiElementErrorClass] = 'has-success';
                        menuStateData[multiElementErrorMessageClass] = '';
                      } else {
                        menuStateData[multiElementErrorClass] = fieldStates[multiElementErrorClass];
                        menuStateData[multiElementErrorMessageClass] = fieldStates[multiElementErrorMessageClass];
                      }
                      allFormFields[submenukey + ":" + multiInputFieldIndex + ":" + multiInputFieldName] = fieldDesign.type_items[0][multiInputFieldName];
                    })
                  })
                }
              }
            }
          });
          fieldStatesData[horizontolmenukey] = menuStateData;
          formFieldsData[horizontolmenukey] = allFormFields;
        })
      })
      setFieldStates(fieldStatesData[horizontalTab]);
      setAllFieldStates(fieldStatesData);
      setFormFields(formFieldsData);
      setCurrentFormFields(formFieldsData[horizontalTab]);
    }
  }, [currentTabConfig])


  // console.log(currentFormFields);
  const storeConfig = async () => {
    // console.log("storeConfig called");
    if (validateConfig()) {
      setShowLoader(true);
      setShowSaveButton(false);
      // console.log(currentTabConfig);
      let saveConfig = await v2AppService.storeAppConfig(templateId, horizontalTab, currentTabConfig,platform);
      if (!saveConfig.status && saveConfig.error.errorCode === 403) {
        context.setIsAuthorized(context);
      }
      else if (saveConfig.status) {
        setTimeout(() => {
          setShowLoader(false)
          setShowSaveButton(true)
          setAlert({ show: true, type: 'success', message: 'Saved Successfully' });
        }, 1000);

        setTimeout(() => {
          setAlert({ show: false, type: '', message: '' });
        }, 3000);
      } else { // Handle other errors from the API
        setTimeout(() => {
          setShowLoader(false);
          setShowSaveButton(true);
          setAlert({ show: true, type: 'danger', message: saveConfig.error?.message || 'Failed to save configuration. Please try again.' });
        }, 1000);
        // Consider if you want the error alert to also auto-hide or stay until dismissed
      }
    }
  }

  const validateConfig = () => {
    let validated = true;
    let firstInvalidFieldId = '';
    Object.keys(currentFormFields).forEach(function (fieldId) {
      let fieldIdArray = fieldId.split(":");
      // console.log("currentTabconfig:",currentTabConfig);
      let fieldValue = '';
      if (fieldIdArray.length == 5) {
        if (!currentTabConfig[fieldIdArray[0]]) {
          currentTabConfig[fieldIdArray[0]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]][fieldIdArray[3]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]][fieldIdArray[3]] = {}
        }
        fieldValue = currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]][fieldIdArray[3]][fieldIdArray[4]];
      } else if (fieldIdArray.length == 4) {
        if (!currentTabConfig[fieldIdArray[0]]) {
          currentTabConfig[fieldIdArray[0]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]] = {}
        }
        fieldValue = currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]][fieldIdArray[3]];
      } else if (fieldIdArray.length == 3) {
        if (!currentTabConfig[fieldIdArray[0]]) {
          currentTabConfig[fieldIdArray[0]] = {}
        }
        if (!currentTabConfig[fieldIdArray[0]][fieldIdArray[1]]) {
          currentTabConfig[fieldIdArray[0]][fieldIdArray[1]] = {}
        }
        fieldValue = currentTabConfig[fieldIdArray[0]][fieldIdArray[1]][fieldIdArray[2]];
      } else if (fieldIdArray.length == 2) {
        if (!currentTabConfig[fieldIdArray[0]]) {
          currentTabConfig[fieldIdArray[0]] = {};
        }
        fieldValue = currentTabConfig[fieldIdArray[0]][fieldIdArray[1]];
      } else {
        fieldValue = currentTabConfig[fieldId];
      }
      // console.log("fieldId in here:",fieldId,fieldValue);
      if (!validateConfigField(fieldId, fieldValue, currentFormFields[fieldId], 'form')) {
        if (firstInvalidFieldId == '') {
          firstInvalidFieldId = fieldId;
        }
        validated = false;
      }
    });
    if (!validated) {
      setFieldStates({
        ...fieldStates
      });

      // console.log("firstInvalidFieldId",firstInvalidFieldId)

      // console.log(document.getElementById(firstInvalidFieldId))
      if (document.getElementById(firstInvalidFieldId)) {
        document.getElementById(firstInvalidFieldId).focus();
      }
    }
    return validated;
  }

  // const validateConfigField = (fieldId, fieldValue, fieldDesign, validationType) =>{
  //     let isValid = true;
  //     const isEffectivelyEmpty = fieldValue === '' || fieldValue === null || fieldValue === undefined || (Array.isArray(fieldValue) && fieldValue.length === 0);

  //     if (fieldDesign && !fieldDesign.required) {
  //       // If the field is not required, it's always "valid" from a validation standpoint.
  //       // Clear any potential error messages.
  //       if (validationType == 'form') {
  //         fieldStates['error_' + fieldId] = 'has-success';
  //         fieldStates['error_message_' + fieldId] = '';
  //       } else {
  //         setFieldStates(prev => ({
  //           ...prev,
  //           ['error_' + fieldId]: 'has-success',
  //           ['error_message_' + fieldId]: '',
  //         }));
  //       }
  //       return true; // No further validation needed for non-required fields.
  //     }

  //     // --- From here, fieldDesign.required is true ---

  //     if (isEffectivelyEmpty) {
  //       // Required field is empty
  //       if (validationType == 'form') {
  //         fieldStates['error_' + fieldId] = 'has-danger';
  //         fieldStates['error_message_' + fieldId] = 'This field is required.';
  //       } else {
  //         setFieldStates(prev => ({
  //           ...prev,
  //           ['error_' + fieldId]: 'has-danger',
  //           ['error_message_' + fieldId]: 'This field is required.',
  //         }));
  //       }
  //       isValid = false;
  //     } else {
  //       // Required field is not empty, proceed with content validation
  //       let contentIsValid = true;
  //       let message = 'Invalid value.'; // Generic message

  //       if (fieldDesign.type == 'url') {
  //         if (!formValidations.verifyUrl(fieldValue)) {
  //           contentIsValid = false;
  //           message = 'Please enter a valid url.';
  //         }
  //       } else if (fieldDesign.type == 'integer') {
  //         if (!formValidations.verifyNumber(fieldValue)) {
  //           contentIsValid = false;
  //           message = 'Please enter a valid number.';
  //         }
  //       } else if (fieldDesign.type == 'enum' || (fieldDesign.source == 'category_list' && fieldDesign.type !== 'array')) {
  //         if (!formValidations.checkValueInArray(fieldValue, fieldDesign.type_items, fieldDesign.type)) {
  //           contentIsValid = false;
  //           message = 'Please enter a valid value.';
  //         }
  //       } else if (fieldDesign.source == 'category_list' && fieldDesign.type === 'array') {
  //          if (Array.isArray(fieldValue)) {
  //             for (const val of fieldValue) {
  //                 if (!formValidations.checkValueInArray(val, fieldDesign.type_items, "string")) { // Assuming values in array are strings
  //                     contentIsValid = false;
  //                     message = 'Please enter a valid value.';
  //                     break;
  //                 }
  //             }
  //         } else if (fieldValue !== '') { 
  //            if (!formValidations.checkValueInArray(fieldValue, fieldDesign.type_items, fieldDesign.type)) {
  //               contentIsValid = false;
  //               message = 'Please enter a valid value.';
  //            }
  //         }
  //       }
  //       // Add other type-specific validations here...

  //       if (!contentIsValid) {
  //         if (validationType == 'form') {
  //           fieldStates['error_' + fieldId] = 'has-danger';
  //           fieldStates['error_message_' + fieldId] = message;
  //         } else {
  //           setFieldStates(prev => ({
  //             ...prev,
  //             ['error_' + fieldId]: 'has-danger',
  //             ['error_message_' + fieldId]: message,
  //           }));
  //         }
  //         isValid = false;
  //       } else {
  //         // Content is valid for a required, non-empty field
  //         if (validationType == 'form') {
  //           fieldStates['error_' + fieldId] = 'has-success';
  //           fieldStates['error_message_' + fieldId] = '';
  //         } else {
  //            setFieldStates(prev => ({
  //             ...prev,
  //             ['error_' + fieldId]: 'has-success',
  //             ['error_message_' + fieldId]: '',
  //           }));
  //         }
  //       }
  //     }
  //     return isValid;
  // }

  const validateEmail = (fieldId, fieldValue, fieldDesign, validationType) => {
    let isValid = true;
    if (fieldValue != '' && !formValidations.verifyEmail(fieldValue)) {
      if (validationType == 'form') {
        fieldStates['error_' + fieldId] = 'has-danger';
        fieldStates['error_message_' + fieldId] = 'Please enter a valid email.';
      } else {
        setFieldStates({
          ...fieldStates,
          ['error_' + fieldId]: 'has-danger',
          ['error_message_' + fieldId]: 'Please enter a valid email.',
        });
      }
      isValid = false;
    } else {
      if (validationType == 'form') {
        fieldStates['error_' + fieldId] = 'has-success';
        fieldStates['error_message_' + fieldId] = '';
      } else {
        setFieldStates({
          ...fieldStates,
          ['error_' + fieldId]: 'has-success',
          ['error_message_' + fieldId]: '',
        });
      }
    }
    return isValid;
  }
  const validatePhone = (fieldId, fieldValue, fieldDesign, validationType) => {
    let isValid = true;
    if (fieldValue != '' && !formValidations.verifyPhoneNumber(fieldValue)) {
      if (validationType == 'form') {
        fieldStates['error_' + fieldId] = 'has-danger';
        fieldStates['error_message_' + fieldId] = 'Please enter a valid phone number.';
      } else {
        setFieldStates({
          ...fieldStates,
          ['error_' + fieldId]: 'has-danger',
          ['error_message_' + fieldId]: 'Please enter a valid phone number.',
        });
      }
      isValid = false;
    } else {
      if (validationType == 'form') {
        fieldStates['error_' + fieldId] = 'has-success';
        fieldStates['error_message_' + fieldId] = '';
      } else {
        setFieldStates({
          ...fieldStates,
          ['error_' + fieldId]: 'has-success',
          ['error_message_' + fieldId]: '',
        });
      }
    }
    return isValid;

  }

  const validateConfigField = (fieldId, fieldValue, fieldDesign, validationType) => {
    let isValid = true;
    let fieldIdArray = fieldId.split(":");
    if (fieldDesign && fieldDesign.parent_field && (currentTabConfig[fieldIdArray[0]]?.[fieldIdArray[1]]?.[fieldIdArray[2]]?.[fieldDesign.parent_field]) !== (fieldDesign.parent_value)) {
      return isValid;
    } else {
      if (fieldDesign && fieldDesign.type === 'multi-input' && fieldDesign.total_items) {
        if (fieldValue && fieldValue.length < fieldDesign.total_items) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = `Please Select at least ${fieldDesign.total_items} values`;
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: `Please Select at least ${fieldDesign.total_items} values`,
            });
          }
          isValid = false;
        }
      }
      if (fieldDesign && (fieldDesign.type == 'string' || fieldDesign.type == 'integer' || fieldDesign.type == 'url' || fieldDesign.type == 'enum' || fieldDesign.type == 'file_upload' || fieldDesign.type == 'json') && fieldDesign.required) {
        if (fieldValue == '' || fieldValue === undefined) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'This field is required.';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'This field is required.',
            });
          }
          isValid = false;
        } else {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            });
          }
        }
      }
      if (isValid && fieldDesign && fieldDesign.type == 'string' && fieldDesign.validations) {

        for (const value of fieldDesign.validations) {
          switch (value) {
            case "email":
              isValid = validateEmail(fieldId, fieldValue, fieldDesign, validationType);
              break;
            case "phone":
              isValid = validatePhone(fieldId, fieldValue, fieldDesign, validationType);
              break;
          }

        }
      }
      if (isValid && fieldDesign && fieldDesign.type == 'url') {
        if (fieldValue && !formValidations.verifyUrl(fieldValue)) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'Please enter a valid url.';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'Please enter a valid url.',
            });
          }
          isValid = false;
        } else {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            });
          }
        }
      }

      if (isValid && fieldDesign && fieldDesign.type == 'json') {
        const strVal = fieldValue === undefined || fieldValue === null ? '' : String(fieldValue);
        if (fieldDesign.required && strVal.trim() === '') {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'This field is required.';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'This field is required.',
            });
          }
          isValid = false;
        } else if (strVal.trim() !== '') {
          try {
            JSON.parse(strVal);
            if (validationType == 'form') {
              fieldStates['error_' + fieldId] = 'has-success';
              fieldStates['error_message_' + fieldId] = '';
            } else {
              setFieldStates({
                ...fieldStates,
                ['error_' + fieldId]: 'has-success',
                ['error_message_' + fieldId]: '',
              });
            }
          } catch (err) {
            if (validationType == 'form') {
              fieldStates['error_' + fieldId] = 'has-danger';
              fieldStates['error_message_' + fieldId] = 'Enter valid JSON.';
            } else {
              setFieldStates({
                ...fieldStates,
                ['error_' + fieldId]: 'has-danger',
                ['error_message_' + fieldId]: 'Enter valid JSON.',
              });
            }
            isValid = false;
          }
        } else {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            });
          }
        }
      }

      // Integer validation with min/max checks
      if (fieldDesign && fieldDesign.type === 'integer' && fieldDesign.required) {
        console.log("in handleChange in validate of integer: ", fieldDesign);

        if (fieldValue !== '' && !formValidations.verifyNumber(fieldValue)) {
          // Value is not a number
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'Please enter a valid number.';
          } else {
            setFieldStates(prev => ({
              ...prev,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'Please enter a valid number.',
            }));
          }
          isValid = false;
        } else if (fieldValue !== '') { // Only validate min/max if a number is entered
          const numValue = parseInt(fieldValue, 10);
          let specificIntegerError = false;

          if (fieldDesign.minimum !== undefined && numValue < fieldDesign.minimum) {
            const minMessage = `Value must be ${fieldDesign.minimum} or greater.`;
            if (validationType == 'form') {
              fieldStates['error_' + fieldId] = 'has-danger';
              fieldStates['error_message_' + fieldId] = minMessage;
            } else {
              setFieldStates(prev => ({
                ...prev,
                ['error_' + fieldId]: 'has-danger',
                ['error_message_' + fieldId]: minMessage,
              }));
            }
            isValid = false;
            specificIntegerError = true;
          }

          // Only check maximum if minimum check passed (or wasn't applicable)
          if (!specificIntegerError && fieldDesign.maximum !== undefined && numValue > fieldDesign.maximum) {
            const maxMessage = `Value must be ${fieldDesign.maximum} or less.`;
            if (validationType == 'form') {
              fieldStates['error_' + fieldId] = 'has-danger';
              fieldStates['error_message_' + fieldId] = maxMessage;
            } else {
              setFieldStates(prev => ({
                ...prev,
                ['error_' + fieldId]: 'has-danger',
                ['error_message_' + fieldId]: maxMessage,
              }));
            }
            isValid = false;
            specificIntegerError = true;
          }
        }
        // If it's an integer field and it's still considered valid after the above checks
        // (or it was empty and not required, thus not failing the 'required' check earlier)
        if (isValid && (fieldValue === '' || formValidations.verifyNumber(fieldValue))) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates(prev => ({
              ...prev,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            }));
          }
        }
      }

      if (isValid && fieldDesign && fieldDesign.required && fieldDesign.type == 'enum') {
        // console.log(fieldDesign.type_items);
        if (fieldValue != '' && !formValidations.checkValueInArray(fieldValue, fieldDesign.type_items, fieldDesign.type)) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'Please enter a valid value.';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'Please enter a valid value.',
            });
          }
          isValid = false;
        } else {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            });
          }
        }
      }

      if (isValid && fieldDesign && fieldDesign.source == 'category_list' && fieldDesign.required === true) {
        // console.log("in handleChange in validate: ", fieldValue);
        // console.log("in handleChange in validate:", fieldDesign.type_items);
        // console.log("in handleChange in validate:", fieldDesign);
        if (fieldValue != '' && !formValidations.checkValueInArray(fieldValue, fieldDesign.type_items, fieldDesign.type)) {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-danger';
            fieldStates['error_message_' + fieldId] = 'Please enter a valid value.';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-danger',
              ['error_message_' + fieldId]: 'Please enter a valid value.',
            });
          }
          isValid = false;
        } else {
          if (validationType == 'form') {
            fieldStates['error_' + fieldId] = 'has-success';
            fieldStates['error_message_' + fieldId] = '';
          } else {
            setFieldStates({
              ...fieldStates,
              ['error_' + fieldId]: 'has-success',
              ['error_message_' + fieldId]: '',
            });
          }
        }
      }

      return isValid;
    }
  }
  var navItems = [];
  var tabPanes = [];

  Object.keys(configSchema).forEach(function (key) {
    Object.keys(configSchema[key]).forEach(function (configkey) {
      //console.log(configSchema[key][configkey]);
      navItems.push(<NavItem>
        <NavLink
          aria-expanded={
            horizontalTab === configkey
          }
          data-toggle="tab"
          href="#"
          role="tab"
          className={
            horizontalTab === configkey
              ? "active"
              : ""
          }
          onClick={() => {
            setHorizontalTab(configkey)
            // setCurrentTabConfig will be handled by its own useEffect listening to horizontalTab and savedConfig
            // let currentConfig = {};
            // if (savedConfig && savedConfig.data && savedConfig.data[configkey]) {
            //   currentConfig = JSON.parse(savedConfig.data[configkey]);
            // } else if (configSchema) { // Fallback to default if not in savedConfig
            //   currentConfig = generateDefaultConfigForTab(configSchema, configkey);
            // }
            // setCurrentTabConfig(currentConfig);
            setFieldStates(allFieldStates[configkey])
            setCurrentFormFields(formFields[configkey]);
          }
          }
        >
          {configSchema[key][configkey].label}
        </NavLink>
      </NavItem>);
      var showVerticalMenu = false;
      var submenu = configSchema[key][configkey].items;
      Object.keys(submenu).forEach(function (submenukey) {
        if (submenu[submenukey].items) {
          showVerticalMenu = true;
        }
        //console.log(submenu[submenukey]);
      });
      //console.log(configSchema[key][configkey]);
      tabPanes.push(<TabPane tabId={configkey} role="tabpanel">
        <Row>
          <Col md="12">

            <Form action="" className="form-horizontal" method="POST">

              {horizontalTab === configkey ? showVerticalMenu ? <ConfigVerticalMenu templateId={templateId} fieldStates={fieldStates} setFieldStates={setFieldStates} validateConfigField={validateConfigField} categories={categories} setCurrentTabConfig={setCurrentTabConfig} currentTabConfig={currentTabConfig} data={configSchema[key][configkey]} menutype={configkey} resourceList={resourceList} isLoadingResources={isLoadingResources} />

                : <ConfigForm templateId={templateId} fieldStates={fieldStates} setFieldStates={setFieldStates} validateConfigField={validateConfigField} categories={categories} setCurrentTabConfig={setCurrentTabConfig} currentTabConfig={currentTabConfig} data={configSchema[key][configkey]} parent={configkey} subparent='' resourceList={resourceList} isLoadingResources={isLoadingResources} /> : ''}


              {showSaveButton ? <Button
                className="btn-round"
                color="info"
                type="button"
                onClick={storeConfig}
              >
                Save {configSchema[key][configkey].label}
              </Button> : ''}

              {showLoader ? <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner> : ''}

              {alert.show ? <Alert variant={alert.type}>
                {alert.message}
              </Alert> : ''}


            </Form>
          </Col>
        </Row>


      </TabPane>);
    });
  });

  if (!templateId) {

    // <Projects navigate="config/customizations"></Projects>
    history.push("/template/templates");

  } else {

    return (
      <div className="content">
        <Row>
          <Col className="col-md-12">
            <Card>
              <CardHeader>
                <h5>Customize Template</h5>
              </CardHeader>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      {navItems}

                    </Nav>
                  </div>
                </div>
                <TabContent
                  className="text-center"
                  id="my-tab-content"
                  activeTab={horizontalTab}
                >
                  {tabPanes}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer position="bottom-right" autoClose={3000} limit={1} />
      </div>
    );
  }

}

export default EditAppTemplate;


/**
 * url se platform and get, create , edit har jgh platform send krna h 
 */